import { useContext } from "react";
import { RegGroupContext } from "./contextUtils";

// Used to track the Registration ID when creating a new Travel Group

// eslint-disable-next-line import/prefer-default-export
export const useRegGroupContext = () => useContext(RegGroupContext);
